import bgShareImage from "../../../assets/seleccionCOL.jpg";
import simulatorSelectionData from "../json-selections/simulatorSelectionDataCOL.json";
import backgroundEsc from "../../../assets/escudo-col.png";
import { PATH } from "../../../constantes/constantes";

export const selectionCOLConfig = {
  data: simulatorSelectionData,
  backgroundEscudo: backgroundEsc,
  shareImage: bgShareImage,
  shareUrl: PATH + "/futbol/mundial-2026/mundial-2026-arma-tu-convocatoria-de-colombia-con-el-simulador-de-claro-sports/",
  shareText: "Mi lista de la Selección Colombia para el Mundial ",
  shareTitle: "Mi lista de la Selección Colombia para el Mundial ",
  shareFileName: "mi-seleccion-col.png",
  accentColor: "#ffd64f",
  accentColorAlt: "#275db2",
  selectedColor: "var(--color-red)",
  title: "Mi Selección Colombia",
  shareTextColor: "#275db2"
};